import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { ETypographyColor, ETypographySize, ETypographyTag, type TTypographyProps } from "../typography"

import { EButtonSize, EButtonVariant } from "./button.types"

const baseClasses: string = buildCssClassName(
    ["flex", "items-center", "shrink-0", "justify-center", "w-fit", "rounded-[30px]"],
    getTransitionTwClasses("all")
)

const sizeMap: { [S in EButtonSize]: () => string } = {
    [EButtonSize.Medium]: (): string => "px-[25px] py-[8px]",
    [EButtonSize.Small]: (): string => "px-[15px] py-[8px]"
}

const colorMap: { [V in EButtonVariant]: (isDisabled: boolean) => string } = {
    [EButtonVariant.Solid]: (isDisabled: boolean): string =>
        buildCssClassName(isDisabled ? "bg-gray-300" : "bg-blue-200 hover:bg-accent focus:bg-accent"),
    [EButtonVariant.SolidDark]: (isDisabled: boolean): string =>
        buildCssClassName(isDisabled ? "bg-blue-200" : "bg-blue-400 hover:bg-blue-500 focus:bg-blue-500"),
    [EButtonVariant.Outlined]: (isDisabled: boolean): string =>
        buildCssClassName("border-[1px] bg-transparent outline-[1px] outline outline-transparent", [
            isDisabled
                ? "border-gray-300"
                : [
                      "border-blue-200",
                      "hover:border-accent",
                      "focus:border-accent",
                      "hover:outline-accent",
                      "focus:outline-accent"
                  ]
        ])
}

const _typographyColorMap: { [V in EButtonVariant]: (isDisabled: boolean) => ETypographyColor } = {
    [EButtonVariant.Solid]: (_isDisabled: boolean): ETypographyColor => ETypographyColor.White,
    [EButtonVariant.SolidDark]: (isDisabled: boolean): ETypographyColor =>
        isDisabled ? ETypographyColor.Blue300 : ETypographyColor.Accent,
    [EButtonVariant.Outlined]: (isDisabled: boolean): ETypographyColor =>
        isDisabled ? ETypographyColor.Gray23 : ETypographyColor.Black
}

function getTypographyProps(btnVariant: EButtonVariant, isBtnDisabled: boolean): Omit<TTypographyProps, "text"> {
    return {
        tag: ETypographyTag.Span,
        size: ETypographySize.Small,
        color: _typographyColorMap[btnVariant](isBtnDisabled)
    }
}

const config = { colorMap, sizeMap, baseClasses, getTypographyProps }

export { config as buttonConfig }
